import { atom } from 'jotai';

import type { VoucherState } from '@entities/voucher/model/types';

export const initialVoucherState: VoucherState = {
  voucher: {},
  voucherRes: {},
  timerActive: true,
  timerCount: 0,
  btnLoading: false,
  error: {},
};

export const voucherAtom = atom<VoucherState>(initialVoucherState);
